/**
 * Quick View fallback injector
 * Ensures quick view buttons appear if ProductItem init fails.
 *
 * Owner: Theme/Dev
 */
(function() {
  'use strict';

  function init(scope) {
    if (!hasQuickviewTemplate()) return;

    var root = scope && scope.querySelectorAll ? scope : document;
    if (!root.querySelector('[data-replace-quickview]')) return;

    ensureThemeScript(function() {
      tryInitProductItem();
      setTimeout(function() {
        if (root.querySelector('[data-replace-quickview]')) {
          injectQuickview(root);
        }
      }, 200);
    });
  }

  function hasQuickviewTemplate() {
    var template = document.getElementById('btns_pr_temp');
    return !!(template && template.innerHTML && template.innerHTML.indexOf('t4s-pr-quickview') !== -1);
  }

  function ensureThemeScript(done) {
    if (window.T4SThemeSP && window.T4SThemeSP.ProductItem) {
      done();
      return;
    }
    if (window.$script && window.T4Sconfigs && T4Sconfigs.script3 && T4Sconfigs.script3 !== 'none') {
      $script(T4Sconfigs.script3, function() {
        done();
      });
      return;
    }
    done();
  }

  function tryInitProductItem() {
    if (window.T4SThemeSP && T4SThemeSP.ProductItem && typeof T4SThemeSP.ProductItem.init === 'function') {
      try {
        T4SThemeSP.ProductItem.init();
      } catch (e) {
        // No-op: fallback will still attempt injection
      }
    }
  }

  function injectQuickview(root) {
    var template = document.getElementById('btns_pr_temp');
    if (!template) return;

    var raw = template.innerHTML || '';
    if (!raw) return;

    var targets = root.querySelectorAll('[data-replace-quickview]');
    if (!targets.length) return;

    for (var i = 0; i < targets.length; i++) {
      var target = targets[i];
      var product = target.closest('.t4s-product') || target.closest('[data-product-options]');
      if (!product) continue;

      var productId = getProductId(product);
      var productUrl = getProductUrl(product);
      if (!productId || !productUrl) continue;

      var tooltip = target.getAttribute('data-tooltip') || '';
      var html = raw.replace(/t4s_pr_url/g, productUrl).split('[split_t4nt]')[0];
      html = html.replace('data-tooltip="', 'data-tooltip="' + tooltip);
      html = html.replace('data-pr-id="', 'data-id="' + productId);

      var wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      var link = wrapper.firstElementChild;
      if (!link) continue;

      link.setAttribute('href', productUrl);
      if (!link.getAttribute('data-id')) {
        link.setAttribute('data-id', productId);
      }
      if (tooltip && !link.getAttribute('data-tooltip')) {
        link.setAttribute('data-tooltip', tooltip);
      }

      target.replaceWith(link);
    }

    if (window.T4SThemeSP && typeof T4SThemeSP.Tooltip === 'function') {
      try {
        T4SThemeSP.Tooltip();
      } catch (e) {
        // No-op
      }
    }
  }

  function getProductId(product) {
    var options = product.getAttribute('data-product-options');
    if (options) {
      try {
        var parsed = JSON.parse(options);
        if (parsed && parsed.id) return parsed.id;
      } catch (e) {
        // No-op
      }
    }
    var className = product.className || '';
    var match = className.match(/t4s-pr-(\d+)/);
    return match ? match[1] : null;
  }

  function getProductUrl(product) {
    var link = product.querySelector('[data-pr-href]') ||
      product.querySelector('.t4s-full-width-link') ||
      product.querySelector('a[href*="/products/"]');
    var url = link ? (link.getAttribute('data-pr-href') || link.getAttribute('href')) : '';
    if (url && typeof url === 'string' && url.indexOf('/products/none') === -1 && url.indexOf('/products/undefined') === -1) {
      return url;
    }

    var options = product.getAttribute('data-product-options');
    if (options) {
      try {
        var parsed = JSON.parse(options);
        var handle = parsed && parsed.handle ? String(parsed.handle).trim() : '';
        if (handle && handle !== 'none' && handle !== 'undefined') {
          return '/products/' + handle;
        }
      } catch (e) {
        // No-op
      }
    }

    return null;
  }

  // Guarded so this file can be require()'d under plain Node (no jsdom) for unit-testing the
  // pure decision functions below (see the module.exports block at the end of this file) —
  // in any real browser `document` is always defined, so this changes nothing there.
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      init(event.target || document);
    });
  }

  function hasBadProductUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return /\/products\/(?:undefined|none)(?:[/?&]|$)/.test(url);
  }

  function patchImage(img) {
    if (!img) return;
    var src = img.getAttribute('src');
    var dataSrc = img.getAttribute('data-src');
    var dataWebp = img.getAttribute('data-src-webp');

    if (!hasBadProductUrl(src) && !hasBadProductUrl(dataSrc) && !hasBadProductUrl(dataWebp)) return;

    // Prefer an already-known valid CDN source attached on the element.
    var fallback = img.getAttribute('data-master') ||
      img.getAttribute('data-bgset') ||
      img.getAttribute('data-original');

    if (!fallback || hasBadProductUrl(fallback)) {
      fallback = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
    }

    img.setAttribute('src', fallback);
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', fallback);
    if (img.hasAttribute('data-src-webp')) img.setAttribute('data-src-webp', fallback);
    if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
  }

  function guardMalformedImageUrls(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var imgs = root.querySelectorAll('img[src*="/products/undefined"],img[src*="/products/none"],img[data-src*="/products/undefined"],img[data-src*="/products/none"],img[data-src-webp*="/products/undefined"],img[data-src-webp*="/products/none"]');
    for (var i = 0; i < imgs.length; i++) patchImage(imgs[i]);
  }

  // GSC 404 fix (2026-07-05, hardened 2026-07-06): the #btns_pr_temp template (see
  // snippets/render_bottom.liquid) uses the literal placeholder "t4s_pr_url" for the
  // quickview/wishlist/compare/add-to-cart buttons, meant to be replaced with the real product
  // URL before the cloned button reaches the DOM.
  //
  // There are two independent code paths that do this substitution:
  //   1. The core theme bundle (assets/interactable.min.js), which does a blind
  //      raw.replace(/t4s_pr_url/g, productUrl) across the whole template fragment, then
  //      inserts the result with element.replaceWith(...) and never touches href again.
  //   2. injectQuickview() above (our own fallback), which does the same blind replace AND
  //      then explicitly calls link.setAttribute('href', productUrl) afterwards — so it was
  //      never actually vulnerable to this leak on its own.
  //
  // 2026-07-05 fix: because path 1's substitution happened inside href="t4s_pr_url" directly,
  // any race that skipped it (slow section load, an earlier JS error) left the literal
  // placeholder as a real, crawlable href — Search Console logged it as Not found (404), e.g.
  // /collections/<handle>/products/t4s_pr_url. A same-origin fetch() of the raw page HTML
  // (i.e. what a non-JS crawl sees, before any of this JS runs) confirmed href="t4s_pr_url" is
  // present in the server-rendered markup itself — a client-side DOM patch can never fully
  // close that, since it only ever runs after the browser already has the raw HTML.
  //
  // 2026-07-06 fix: the template source (snippets/render_bottom.liquid) no longer puts the
  // placeholder in href at all. Every button now ships as href="javascript:void(0)" (never a
  // real, fetchable URL, in any rendering mode, with or without JS) plus a separate
  // data-pr-url="t4s_pr_url" attribute that is safe to leave un-substituted. The blind
  // raw.replace(/t4s_pr_url/g, ...) in both code paths still finds and replaces that token
  // exactly as before (it doesn't care which attribute it's sitting in), so nothing about the
  // substitution mechanism changed — only path 1 (vendor bundle) now needs help copying the
  // resolved data-pr-url value onto href, which is exactly what patchLink() below does,
  // universally, for buttons produced by either code path.
  function isLeakedPlaceholderHref(href) {
    return typeof href === 'string' && href.indexOf('t4s_pr_url') !== -1;
  }

  function isSafeInertHref(href) {
    return !href || href === 'javascript:void(0)' || href === '#' || isLeakedPlaceholderHref(href);
  }

  // Returns the real product URL once data-pr-url has been substituted by either code path,
  // or null while it's still the raw, un-substituted placeholder.
  function resolvedSlotUrl(link) {
    var slot = link.getAttribute('data-pr-url');
    if (!slot || isLeakedPlaceholderHref(slot)) return null;
    return slot;
  }

  function patchLink(link) {
    if (!link || link.tagName !== 'A') return;
    var href = link.getAttribute('href');

    // Case 1 (2026-07-06 pattern): data-pr-url was already resolved to a real URL by whichever
    // code path populated this button, but href itself was never pointed at it (this is the
    // vendor bundle's code path — see comment above). Sync it.
    var slotUrl = resolvedSlotUrl(link);
    if (slotUrl && isSafeInertHref(href)) {
      link.setAttribute('href', slotUrl);
      return;
    }

    // Case 2 (defensive/legacy): the literal placeholder ended up directly in href or
    // data-pr-href — e.g. stale cached markup from before the 2026-07-06 template change, or a
    // code path we don't know about. Repair from the product card if we can, otherwise remove
    // the dead link so nothing crawlable is left behind.
    var dataHref = link.getAttribute('data-pr-href');
    if (!isLeakedPlaceholderHref(href) && !isLeakedPlaceholderHref(dataHref)) return;

    var product = link.closest('.t4s-product') || link.closest('[data-product-options]');
    var productUrl = product ? getProductUrl(product) : null;

    if (productUrl) {
      link.setAttribute('href', productUrl);
      if (link.hasAttribute('data-pr-href')) link.setAttribute('data-pr-href', productUrl);
    } else {
      // No reliable product URL to resolve to — remove rather than leave a crawlable dead link.
      link.parentNode && link.parentNode.removeChild(link);
    }
  }

  function guardMalformedActionLinks(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var links = root.querySelectorAll('a[data-pr-url],a[href*="t4s_pr_url"],a[data-pr-href*="t4s_pr_url"]');
    for (var i = 0; i < links.length; i++) patchLink(links[i]);
  }

  function guardScope(scope) {
    guardMalformedImageUrls(scope);
    guardMalformedActionLinks(scope);
  }

  // Guarded for the same reason as the block above — lets this file load under plain Node
  // for unit tests without a MutationObserver/document polyfill, with zero behavior change
  // in a real browser.
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        guardScope(document);
      });
    } else {
      guardScope(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      guardScope(event.target || document);
    });

    var imageObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes' && mutation.target) {
          if (mutation.target.tagName === 'IMG') patchImage(mutation.target);
          if (mutation.target.tagName === 'A') patchLink(mutation.target);
        }
        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node && node.nodeType === 1) {
              if (node.tagName === 'IMG') patchImage(node);
              if (node.tagName === 'A') patchLink(node);
              guardScope(node);
            }
          }
        }
      }
    });

    imageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'data-src', 'data-src-webp', 'href', 'data-pr-href', 'data-pr-url']
    });
  }

  // Test-only export (see assets/oauth-auth.js for the same convention). `module` is never
  // defined in a browser, so this is a no-op there — it only runs under Node/Vitest, letting
  // test/unit/seo-crawl-link-safety.test.js exercise the real decision functions above against
  // fake DOM-node doubles instead of a reimplemented copy of the logic.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      hasBadProductUrl,
      isLeakedPlaceholderHref,
      isSafeInertHref,
      resolvedSlotUrl,
      patchLink,
      getProductUrl,
      getProductId
    };
  }
})();
